import React from 'react';

/** Shimmering skeleton box (for loading placeholders in the mobile PWA). */
export const SkeletonBox = ({ className = '', style }) => (
  <div
    className={`bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 bg-[length:200%_100%] animate-shimmer rounded-lg ${className}`}
    style={style}
    aria-hidden="true"
  />
);

/** Relocation-card skeleton — matches AppRelocations row dimensions. */
export const SkeletonRelocationCard = () => (
  <div className="w-full bg-white border border-gray-200 rounded-xl p-3">
    <div className="flex items-center justify-between mb-2">
      <SkeletonBox className="h-4 w-2/5" />
      <SkeletonBox className="h-4 w-16" />
    </div>
    <SkeletonBox className="h-3 w-3/4 mb-2" />
    <SkeletonBox className="h-3 w-1/3" />
  </div>
);

/** Stat-card skeleton — matches AppHome stat cards. */
export const SkeletonStatCard = () => (
  <div className="bg-white border border-gray-200 rounded-xl p-3">
    <SkeletonBox className="h-3 w-2/3 mb-2" />
    <SkeletonBox className="h-7 w-1/2" />
  </div>
);

/** List of skeleton rows (tap-friendly for invoices/receipts lists). */
export const SkeletonListRow = () => (
  <div className="w-full bg-white border border-gray-200 rounded-xl p-3 flex items-center gap-3">
    <SkeletonBox className="w-10 h-10 rounded-full" />
    <div className="flex-1 space-y-2">
      <SkeletonBox className="h-3 w-3/5" />
      <SkeletonBox className="h-3 w-2/5" />
    </div>
    <SkeletonBox className="h-6 w-12" />
  </div>
);
